export function textDateFormat(txtFecha: string){
    if(txtFecha === null || txtFecha === ''){
        return '';
    }else{
        return txtFecha.split("T")[0];   
    }
}

export function textDateTimeFormat(txtFecha: string){
    if(txtFecha === null || txtFecha === ''){
        return '';
    }else{
        return txtFecha.split("T")[0]+" "+txtFecha.split("T")[1].substring(0,5);   
    }
}